export const SkrillEnv = {
  //staging env
  keys: import.meta.env.VITE_API_KEY_SKRILL,
  Env: import.meta.env.VITE_API_ENV_SKRILL, 

};
